import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { RegexpSearch } from '../../shared/helpers/regex';
import { ApiService } from '../../shared/services/api/api.service';
import { DisplayedTerritoryWatch } from '../../models/territory-watch';
import { first } from 'rxjs/operators';
import { firstValueFrom } from "rxjs";

@Component({
  selector: 'app-territory-watches-page',
  templateUrl: './territory-watches-page.component.html',
  styleUrls: ['./territory-watches-page.component.scss']
})
export class TerritoryWatchesPageComponent implements OnInit {

  territoryWatches!: Array<DisplayedTerritoryWatch>;
  filteredTerritoryWatches!: Array<DisplayedTerritoryWatch>;
  filterTerritoryWatchNameFormControl = new FormControl() ;
  showClearIcon = false;

  constructor(
    private readonly apiService: ApiService,
  ) {
  }

  ngOnInit(): void {

    const userId = localStorage.getItem('user_id');
    const fields: Array <string> = ['id', 'name', 'users', 'is_obsolete', 'created_at', 'updated_at', 'settings_json'];
    const filters: object = { 'user_ids': [parseInt(userId ?? '', 10)] };

    this.apiService.territoryWatch.getTerritoryWatches(fields, filters)
      .pipe(first())
      .subscribe((retrievedTerritoryWatches) => {
        this.territoryWatches = this.apiService.territoryWatch.addCurrentUserToTerritoryWatches(retrievedTerritoryWatches);
        this.filteredTerritoryWatches = this.territoryWatches;
    });

    this.filterTerritoryWatchNameFormControl.valueChanges
      .subscribe(searchText => {
        if ((searchText != null) && (searchText.length > 0)) {
          this.filterTerritoryWatch(searchText);
          this.showClearIcon = true;
        } else {
          this.resetFilteredTerritoryWatch();
          this.showClearIcon = false;
        }
    });
  }

  clearText() {
    this.filterTerritoryWatchNameFormControl.setValue('') ;
  }

  filterTerritoryWatch(searchText: string) {
    this.filteredTerritoryWatches = this.territoryWatches.filter(item => RegexpSearch.normalizedSearch(item.name, searchText));
  }

  resetFilteredTerritoryWatch() {
    this.filteredTerritoryWatches = this.territoryWatches;
  }

  async onSelectChange(value: any) {
    const {itemId, isActive} = value;
    await firstValueFrom(this.apiService.userTerritoryWatches.switchTerritoryWatchActiveState(itemId, isActive)).catch(
      error => {
        console.log(error);
      }
    );
  }

  async renameTerritoryWatch(value: DisplayedTerritoryWatch) {
    await firstValueFrom(this.apiService.territoryWatch.updateTerritoryWatch(value));
  }

  async deleteTerritoryWatch(value: any) {
    await firstValueFrom(this.apiService.territoryWatch.deleteTerritoryWatch(value))
      .catch(
        error => {
          console.log(error);
        }
      );
  }
}
